<template>
  <v-container>
    <v-card
      :loading="false"
    >
      <v-overlay
        :absolute="true"
        :value="isComponentLoading"
      >
        <v-progress-circular indeterminate size="24"></v-progress-circular>
      </v-overlay>
      <v-row class="pa-3">
        <v-col cols="12" md="6">
          <v-text-field
            v-model="searchText"
            :hint="lang($store, 'sap/listings.global.filter.hints.search_name_contact')"
            persistent-hint
            single-line
            :loading="false"
          />
        </v-col><v-col cols="12" md="6">
          <v-text-field
            v-model="searchTextCleaner"
            :hint="lang($store, 'sap/listings.global.filter.hints.search_name_cleaner')"
            persistent-hint
            single-line
            :loading="false"
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-menu
            v-model="menuFrom"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="fromDateFormatted"
                @input="changeDate('from', $event)"
                :label="lang($store, 'sap/listings.global.filter.hints.date_from')"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="searchParams.from" no-title
                           :first-day-of-week="1"
                           :locale="getCurrentLocale()"
                           @input="menuFrom = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="6">
          <v-menu
            v-model="menuTo"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="toDateFormatted"
                @input="changeDate('to', $event)"
                :label="lang($store, 'sap/listings.global.filter.hints.date_to')"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="searchParams.to" no-title
                           :first-day-of-week="1"
                           :locale="getCurrentLocale()"
                           @input="menuTo = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="searchParams.salary_is_payed"
            :hint="lang($store, 'sap/listings.global.filter.hints.is_payed')"
            :items="payedItems"
            persistent-hint
            single-line
            :loading="false"
          ></v-select>
        </v-col>
        <v-col
          v-if="subscriptionItems"
          cols="12"
          md="4">
          <v-select
            v-model="searchParams.subscription"
            :hint="lang($store, 'sap/listings.global.filter.hints.subscription')"
            :items="subscriptionItems"
            persistent-hint
            single-line
            :loading="false"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="searchParams.region"
            :hint="lang($store, 'sap/listings.global.filter.hints.region')"
            :items="regionsItems"
            persistent-hint
            single-line
            :loading="false"
          ></v-select>
        </v-col>
      </v-row>
      <download-file-button
        v-if="account.role === MANAGER_TOP"
        :use-download-report-users="true"
        style="position: absolute; top: 5px; right: 5px"
        @click="$emit('download-excel')"
      />
    </v-card>
  </v-container>
</template>

<script>
import moment from 'moment';
/* constants */
/* mixins */
import isComponentLoading from '@/mixins/isComponentLoading';
import regionsFilter from '@/mixins/filters/regionsFilter';
import subscriptionFilter from '@/mixins/filters/subscriptionFilter';
import payedFilter from '@/mixins/filters/payedFilter';
import searchTextFilter from '@/mixins/filters/searchTextFilter';
import searchCleanerFilter from '@/mixins/filters/searchCleanerFilter';
import { MANAGER_TOP } from '@/constants/roles';
import { DATE_ISO } from '@/constants/dates';
import * as orderStatuses from '../../constants/order_statuses';
/* components */
import DownloadFileButton from '../minialerts/DownloadFileButton.vue';


export default {
  name: 'FilterSalary',
  mixins: [
    isComponentLoading,
    regionsFilter,
    subscriptionFilter,
    payedFilter,
    searchTextFilter,
    searchCleanerFilter,
  ],
  components: {
    DownloadFileButton,
  },
  props: {
    defaultSearchParams: {
      type: Object,
      default: () => ({
        subscription: '',
        search_contact: '',
        search_cleaner: '',
      }),
    },
  },
  data() {
    return {
      MANAGER_TOP,
      searchParams: {},
      menuFrom: false,
      menuTo: false,
    };
  },
  mounted() {
    this.searchParams = {
      search_contact: this.defaultSearchParams.search_contact,
      search_cleaner: this.defaultSearchParams.search_cleaner,
      subscription: this.defaultSearchParams.subscription,
      from: moment()
        // .subtract(7, 'days')
        .startOf('day')
        .format(DATE_ISO),
      to: null,
      statuses: [
        orderStatuses.ORDERED,
      ],
      salary_is_payed: null,
      region: null,
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
    fromDateFormatted() {
      return this.formatDate(this.searchParams.from);
    },
    toDateFormatted() {
      return this.formatDate(this.searchParams.to);
    },
  },
  watch: {
    searchParams: {
      handler(newVal) {
        this.$emit('filtering', newVal);
      },
      deep: true,
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    changeDate(type, date) {
      if (date === null) {
        this.searchParams[type] = null;
      }
    },
    getCurrentLocale() {
      return window.localStorage.language;
    },
  },
};
</script>

<style scoped>

</style>
